import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles(() => {
  return {
    iconField: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: -3,
    },
    icon: {
      marginRight: 8,
    },
  }
})
